import React from 'react';
import FormObjectListItem from './FormObjectListItem';

const FormObjectDescriptionListItems = ({
  canEdit,
  category,
  code,
  component,
  onChange,
  field,
  showEdit,
  text,
}) => (
  field.fields.map((item) => (
    <FormObjectListItem
      canEdit={canEdit}
      category={category}
      code={code}
      component={component(item)}
      field={item}
      key={`form_object_list_item${item.name}`}
      onChange={(value) => onChange(field, item, value)}
      showEdit={showEdit}
      text={text(field, item)}
    />
  ))
);

export default FormObjectDescriptionListItems;
